export function isSubscribed(dgsInfo) {
  return Boolean(dgsInfo && dgsInfo.subscription);
}



// WEBPACK FOOTER //
// ./src/shared/utils/dgs-helpers.js